import styled from 'styled-components';

export const DashboardWrapper = styled.div`
  float:left;
  width:100%;
  display:flex;
  padding: 0 25px;
`;
